import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { ProductItem } from "../../../site";
import { ProductDataResponse, ProductPageFactory } from "../../core";

export class ProductPageFactoryImpl implements ProductPageFactory {
    create(productItemData: ProductDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (productItemData?.success && productItemData.success === true) {
            return <ProductItem data={productItemData.response} />
        }
        return <NoDataComponent />
    }
}